/**************************************************************************************************************************
 Copyright (c) 2024 WorkEarly Results LLP

     Name: index.tsx
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPORTS
***************************************************************************************************************************/
import Intro from './intro.section';
import AboutUs from './about-us.section';
import AffiliationsAndSoftwares from './affiliations-softwares.section';
import Services from './services.section';
import Testimonials from './testimonials.section';
import Footer from './footer.section';
import Projects from './projects.section';
import Contact from './contact.section';
import Intros from './intro.section';
import Careers from './careers.section';
/**************************************************************************************************************************
 EXPORTS
***************************************************************************************************************************/
const Sections = {
  Intro,
  AboutUs,
  AffiliationsAndSoftwares,
  Services,
  Testimonials,
  Footer,
  Projects,
  Careers,
  Contact,
  Intros
};

export default Sections;
